import Vue from 'vue'
import { formataMoeda, removeMoeda, formataCpfCnpj } from '../functions/numero'
Vue.filter('formataMoeda', formataMoeda)
Vue.filter('removeMoeda', removeMoeda)
Vue.filter('formataCpfCnpj', formataCpfCnpj)